'use client';
import { ReactNode } from 'react';
import cn from 'classnames';

import './BackgroundColorContainer.style.scss';

type BackgroundColorContainerProps = {
  className?: string;
  color: string;
  children: ReactNode;
};

function BackgroundColorContainer(props: BackgroundColorContainerProps) {
  const { className = '', color, children } = props;

  return (
    <div
      className={cn('BackgroundColorContainer', className)}
      style={{ backgroundColor: color }}
    >
      <div className='shell-contained'>{children}</div>
    </div>
  );
}

export default BackgroundColorContainer;
